var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0288D1",
    d: "M5.747 11.842h.068c3.627 0 5.885-2.631 5.885-5.921C11.632 2.559 9.442 0 5.884 0S0 2.56 0 5.921c0 3.29 2.257 5.921 5.747 5.921M0 15.79h11.7V50H0zm52 12.5c0-6.904-5.529-12.5-12.35-12.5-3.969 0-7.49 1.902-9.75 4.847V15.79H18.2V50h11.7V30.263c0-2.906 2.328-5.263 5.2-5.263s5.2 2.357 5.2 5.263V50H52z"
  })));
};
export default SvgLinkedin;